<div class="modal-header"><h2 class="modal-title">Auction Item</h2></div>
<div class="modal-body">
  @if (auctionItem) {
    <div class="m-2">
      <dx-form [formData]="auctionItem" validationGroup="mainValidationGroup">
        <dxi-item dataField="created" [label]="{ text: 'Date' }" [disabled]="true"></dxi-item>
        <dxi-item [label]="{ text: 'Item Type' }">
          <div *dxTemplate>
            <dx-select-box [(value)]="auctionItem.type" [dataSource]="auctionItemTypes"></dx-select-box>
          </div>
          <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
          <dxi-validation-rule type="range" [min]="'1'" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        @if (auctionItem.type === 'Raffle Line') {
          <dxi-item
            dataField="linePrice"
            [label]="{ text: 'Line Price' }"
            [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0 }"
          ></dxi-item>
        }
        <dxi-item dataField="name" [label]="{ text: 'Name' }"></dxi-item>
        <dxi-item dataField="description" [label]="{ text: 'Description' }" editorType="dxTextArea" editorOptions="{height: 100px}" ></dxi-item>
        <dxi-item dataField="donatedBy" [label]="{ text: 'Donated By' }"></dxi-item>
        <dxi-item dataField="isDonationQualified" [label]="{ text: 'Donation Qualified' }"></dxi-item>
        <dxi-item dataField="marketValue" [label]="{ text: 'Value' }" [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0 }"></dxi-item>
        <dxi-item dataField="minimumBid" [label]="{ text: 'Min. Bid' }" [editorOptions]="{ format: { type: 'currency', precision: 2 }, step: 0 }"></dxi-item>
      </dx-form>
    </div>
  }
</div>
<div class="modal-footer">
  <button class="btn btn-success" (click)="save()">Save</button>
  <button class="btn btn-primary" (click)="close()">Close</button>
</div>
